import { useSelector } from 'react-redux';

import { RootState } from '../../rootReducer';

export const useIsQuoteLiked = (quoteId: string): boolean | undefined => {
  return useSelector<RootState, boolean | undefined>(
    state => state.quotes.liked[quoteId]
  );
};
